import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AiCategoryDefinition } from "@/components/dropdown/CategoryDropdown/CategoryDropdown.types";

export type { AiCategoryDefinition };

export interface CategoriesState {
  categories: AiCategoryDefinition[];
  loaded: boolean;
}

const initialState: CategoriesState = {
  categories: [],
  loaded: false,
};

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategories: (state, action: PayloadAction<AiCategoryDefinition[]>) => {
      state.categories = action.payload;
      state.loaded = true;
    },
  },
});

export const { setCategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;
